import { TextStyleType } from "@faire/web-api--source/indigofair/data/TextStyleType";

export const getTypographyFontSize = (variant: keyof typeof TextStyleType) => {
  return textStyleToFontSizeMap[variant];
};

const textStyleToFontSizeMap: Record<TextStyleType, string | undefined> = {
  [TextStyleType.LABEL]: "12px",
  [TextStyleType.PARAGRAPH]: "14px",
  [TextStyleType.SUBHEADING]: "18px",
  [TextStyleType.SECTION_HEADER]: "22px",
  [TextStyleType.PAGE_HEADER]: "22px",
  [TextStyleType.DISPLAY_S_SANS]: "30px",
  [TextStyleType.DISPLAY_S_SERIF]: "30px",
  [TextStyleType.DISPLAY_M]: "38px",
  [TextStyleType.DISPLAY_L]: "52px",
  [TextStyleType.DISPLAY_XL]: "72px",
  [TextStyleType.TEXT_STYLE_TYPE_UNKNOWN]: undefined,
};
